import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppTheme from '../../shared-theme/AppTheme';
import AppAppBar from '../landing/AppAppBar';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/system';
import { collection, query, where, getDocs , addDoc} from "firebase/firestore";
import { db } from "../../firebase"; 
import { useAuth } from "../../context/AuthContext"; 
import { useEffect, useState } from "react";
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import { signOut } from "firebase/auth";
import { auth } from "../../firebase"; 
import { useNavigate } from "react-router-dom";
import { Step, StepLabel, Stepper, TextField,} from "@mui/material";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));


const logoStyle = {
  width: '64px',
  opacity: 0.3,
};


const generateRandomCode = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const generateUniqueEventCode = async () => {
  let isUnique = false;
  let eventCode = "";
  const eventsRef = collection(db, "events");

  while (!isUnique) {
    eventCode = generateRandomCode();
    const q = query(eventsRef, where("eventCode", "==", eventCode));
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      isUnique = true;
    }
  }

  return eventCode;
};


export default function CreateEvent(props) {
  const theme = useTheme();
  
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

    // custom
    const { currentUser } = useAuth(); // or use auth.currentUser directly

    const displayName = currentUser.displayName || "User";
    const email = currentUser.email;
    const photo = currentUser.photoURL || `https://ui-avatars.com/api/?name=${displayName}`;
  
    const navigate = useNavigate();
    
      const handleLogout = async () => {
        try {
          await signOut(auth);
          console.log("Logged out");
          // Optionally redirect to login
          navigate("/");
        } catch (error) {
          console.error("Logout failed:", error.message);
        }
      };
    // end of custom

    const [formData, setFormData] = useState({
      eventName: "",
      eventLocation: "",
      startDate: dayjs(),
      endDate: dayjs(),
    });
  
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
  
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  
    const handleDateChange = (key, value) => {
      setFormData({ ...formData, [key]: value });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const eventCode = await generateUniqueEventCode();
  
        const docRef = await addDoc(collection(db, "events"), {
          ...formData,
          startDate: formData.startDate.toISOString(),
          endDate: formData.endDate.toISOString(),
          eventOwnerEmail: currentUser?.email || "unknown",
          eventCode,
          createdAt: new Date().toISOString(),
        });
  
        setSuccessMsg("Event created successfully!");
        setFormData({
          eventName: "",
          eventLocation: "",
          startDate: dayjs(),
          endDate: dayjs(),
        });
  
        navigate(`/admin/${docRef.id}`);
      } catch (error) {
        console.error("Error adding event:", error);
      } finally {
        setLoading(false);
      }
    };
  
  
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      {/* App bar */}
      <AppBar
            position="fixed"
            enableColorOnDark
            sx={{
              boxShadow: 0,
              bgcolor: 'transparent',
              backgroundImage: 'none',
              mt: 'calc(var(--template-frame-height, 0px) + 28px)',
            }}
          >
            <Container maxWidth="lg">
              {/* <StyledToolbar variant="dense" disableGutters> */}
                
                <Box
                  sx={{
                    display: { xs: 'none', md: 'flex' },
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  <Button color="primary" variant="text" size="small" onClick={handleLogout} >                    
                      Sign Out                    
                  </Button>                  
                  <ColorModeIconDropdown />
                </Box>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
                  <Button color="primary" variant="text" size="small" as={Link} to="/signin">
                    <Link href="/signin" variant="body2" sx={{ alignSelf: 'center' }} >
                      Sign Out
                    </Link>             
                  </Button> 
                  <ColorModeIconDropdown size="medium" />
                  <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
                    <MenuIcon />
                  </IconButton>
                  <Drawer
                    anchor="top"
                    open={open}
                    onClose={toggleDrawer(false)}
                    PaperProps={{
                      sx: {
                        top: 'var(--template-frame-height, 0px)',
                      },
                    }}
                  >
                    <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <IconButton onClick={toggleDrawer(false)}>
                          <CloseRoundedIcon />
                        </IconButton>
                      </Box>
      
                      
                      <Divider sx={{ my: 3 }} />
                      <MenuItem>
                        <Button color="primary" variant="contained" fullWidth>
                          Sign up
                        </Button>
                      </MenuItem>
                      <MenuItem>
                        <Button color="primary" variant="outlined" fullWidth>
                        <Link
                    href="/signup"
                    variant="body2"
                    sx={{ alignSelf: 'center' }}
                  >
                    Sign up
                  </Link>
                        </Button>
                      </MenuItem>
                    </Box>
                  </Drawer> 
                </Box>
              {/* </StyledToolbar> */}
            </Container>
      </AppBar>


      <div>  
         <Container
              id="testimonials"
              sx={{
                pt: { xs: 4, sm: 12 },
                pb: { xs: 8, sm: 16 },
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 3, sm: 6 },
              }}
            >
              <Box
                sx={{
                  width: { sm: '100%', md: '60%' },
                  textAlign: { sm: 'left', md: 'center' },
                }}
              >
                <Stack
                        direction="row"
                        sx={{
                          p: 2,
                          gap: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          // borderTop: '1px solid',
                          borderColor: 'divider',
                        }}
                      >
                        <Avatar
                          sizes="small"
                          alt={email}
                          src={photo}
                          sx={{ width: 64, height: 64 }}
                        />
                        <Box>
                          <Typography variant="h5" gutterBottom sx={{ color: 'text.primary' , fontWeight: 500, lineHeight: '16px' }}>
                          Hi, {displayName}
                          </Typography>
                        </Box>
                      </Stack>              
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  Create
                </Typography>                
              </Box>

              <Card
                    variant="outlined"
                    sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
                  >
                    <CardContent>
                    <Typography variant="h5" gutterBottom>Create New Event</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Event Name"
          name="eventName"
          fullWidth
          margin="normal"
          value={formData.eventName}
          onChange={handleChange}
          required
        />
        <TextField
          label="Event Location"
          name="eventLocation"
          fullWidth
          margin="normal"
          value={formData.eventLocation}
          onChange={handleChange}
          required
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            label="Start Date & Time"
            value={formData.startDate}
            onChange={(val) => handleDateChange("startDate", val)}
            renderInput={(params) => (
              <TextField {...params} margin="normal" fullWidth required />
            )}
          />
          <DateTimePicker
            label="End Date & Time"
            value={formData.endDate}
            onChange={(val) => handleDateChange("endDate", val)}
            renderInput={(params) => (
              <TextField {...params} margin="normal" fullWidth required />
            )}
          />
        </LocalizationProvider>

        <Box sx={{ mt: 3 }}>
          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? "Creating..." : "Create Event"}
          </Button>
        </Box>

        {successMsg && (
          <Typography color="green" sx={{ mt: 2 }}>{successMsg}</Typography>
        )}
      </form>
                      
                    </CardContent>
                  </Card>
              
          </Container>
      </div>
    </AppTheme>
  );
}
